import ajax from 'src/ajax'
import get from 'lodash/get'

// import fileDownload from 'js-file-download'

const API_PATH = `order`
// *********************************
// Actions
// *********************************
const FETCH_PAYMENT_DETAIL_REQUEST = `FETCH_PAYMENT_DETAIL_REQUEST`
const FETCH_PAYMENT_DETAIL_REQUEST_SUCCESS = `FETCH_PAYMENT_DETAIL_REQUEST_SUCCESS`
const FETCH_PAYMENT_DETAIL_REQUEST_FAIL = `FETCH_PAYMENT_DETAIL_REQUEST_FAIL`
const FETCH_PAYMENT_DETAIL_INVOICE_FILE_REQUEST = `FETCH_PAYMENT_DETAIL_INVOICE_FILE_REQUEST`
const FETCH_PAYMENT_DETAIL_INVOICE_FILE_SUCCESS = `FETCH_PAYMENT_DETAIL_INVOICE_FILE_SUCCESS`
const FETCH_PAYMENT_DETAIL_INVOICE_FILE_FAIL = `FETCH_PAYMENT_DETAIL_INVOICE_FILE_FAIL`
const FETCH_PAYMENT_DETAIL_RECEIPT_FILE_REQUEST = `FETCH_PAYMENT_DETAIL_RECEIPT_FILE_REQUEST`
const FETCH_PAYMENT_DETAIL_RECEIPT_FILE_SUCCESS = `FETCH_PAYMENT_DETAIL_RECEIPT_FILE_SUCCESS`
const FETCH_PAYMENT_DETAIL_RECEIPT_FILE_FAIL = `FETCH_PAYMENT_DETAIL_RECEIPT_FILE_FAIL`
const FETCH_PAYMENT_DETAIL_UPDATE_BAD_DEBT_REQUEST = `FETCH_PAYMENT_DETAIL_UPDATE_BAD_DEBT_REQUEST`
const FETCH_PAYMENT_DETAIL_UPDATE_BAD_DEBT_SUCCESS = `FETCH_PAYMENT_DETAIL_UPDATE_BAD_DEBT_SUCCESS`
const FETCH_PAYMENT_DETAIL_UPDATE_BAD_DEBT_FAIL = `FETCH_PAYMENT_DETAIL_UPDATE_BAD_DEBT_FAIL`
const FETCH_PAYMENT_DETAIL_UPDATE_PAYMENT_REQUEST = `FETCH_PAYMENT_DETAIL_UPDATE_PAYMENT_REQUEST`
const FETCH_PAYMENT_DETAIL_UPDATE_PAYMENT_SUCCESS = `FETCH_PAYMENT_DETAIL_UPDATE_PAYMENT_SUCCESS`
const FETCH_PAYMENT_DETAIL_UPDATE_PAYMENT_FAIL = `FETCH_PAYMENT_DETAIL_UPDATE_PAYMENT_FAIL`

// *********************************
// Action Creators
// *********************************
export const fetchPaymentDetail = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PAYMENT_DETAIL_REQUEST })
    const options = { method: 'GET', url: `${API_PATH}/${id}` }
    const response = await ajax(options)
    const payload = get(response, 'data.order', {})
    dispatch({ type: FETCH_PAYMENT_DETAIL_REQUEST_SUCCESS, payload })
  } catch (error) {
    const code = get(error, 'response.status')
    const text = get(error, 'response.data.message')
    dispatch({ type: FETCH_PAYMENT_DETAIL_REQUEST_FAIL, payload: `${code} : ${text}` })
  }
}

export const downloadInvoice = (order_no, id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PAYMENT_DETAIL_INVOICE_FILE_REQUEST })
    const options = { method: 'GET', url: `/order/${id}/invoice`, responseType: 'blob' }
    const response = await ajax(options)
    const fileURL = URL.createObjectURL(response.data)
    window.open(fileURL)
    dispatch({ type: FETCH_PAYMENT_DETAIL_INVOICE_FILE_SUCCESS })
  } catch (error) {
    dispatch({ type: FETCH_PAYMENT_DETAIL_INVOICE_FILE_FAIL })
  }
}

export const downloadReceipt = (order_no, id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PAYMENT_DETAIL_RECEIPT_FILE_REQUEST })
    const options = { method: 'GET', url: `/order/${id}/receipt`, responseType: 'blob' }
    const response = await ajax(options)
    const fileURL = URL.createObjectURL(response.data)
    window.open(fileURL)
    dispatch({ type: FETCH_PAYMENT_DETAIL_RECEIPT_FILE_SUCCESS })
  } catch (error) {
    dispatch({ type: FETCH_PAYMENT_DETAIL_RECEIPT_FILE_FAIL })
  }
}

export const updateBaddebt = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PAYMENT_DETAIL_UPDATE_BAD_DEBT_REQUEST })
    const options = { method: 'PUT', url: `order/${id}/bad-debt` }
    await ajax(options)
    await dispatch(fetchPaymentDetail(id))
    dispatch({ type: FETCH_PAYMENT_DETAIL_UPDATE_BAD_DEBT_SUCCESS })
  } catch (error) {
    dispatch({ type: FETCH_PAYMENT_DETAIL_UPDATE_BAD_DEBT_FAIL })
  }
}

export const updatePayment = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PAYMENT_DETAIL_UPDATE_PAYMENT_REQUEST })
    const options = { method: 'PUT', url: `order/${id}/paid` }
    await ajax(options)
    await dispatch(fetchPaymentDetail(id))
    dispatch({ type: FETCH_PAYMENT_DETAIL_UPDATE_PAYMENT_SUCCESS })
  } catch (error) {
    dispatch({ type: FETCH_PAYMENT_DETAIL_UPDATE_PAYMENT_FAIL })
  }
}
// *********************************
// Reducer
// *********************************
const initialState = {
  fetching: false,
  error: null,
  data: null,
  processing: false,
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_PAYMENT_DETAIL_REQUEST:
      return { ...state, fetching: true, error: null }
    case FETCH_PAYMENT_DETAIL_REQUEST_FAIL:
      return { ...state, fetching: false, data: null, error: action.payload }
    case FETCH_PAYMENT_DETAIL_REQUEST_SUCCESS:
      return { ...state, fetching: false, data: action.payload }
    case FETCH_PAYMENT_DETAIL_INVOICE_FILE_REQUEST:
    case FETCH_PAYMENT_DETAIL_RECEIPT_FILE_REQUEST:
    case FETCH_PAYMENT_DETAIL_UPDATE_BAD_DEBT_REQUEST:
    case FETCH_PAYMENT_DETAIL_UPDATE_PAYMENT_REQUEST:
      return { ...state, processing: true }
    case FETCH_PAYMENT_DETAIL_INVOICE_FILE_SUCCESS:
    case FETCH_PAYMENT_DETAIL_RECEIPT_FILE_SUCCESS:
    case FETCH_PAYMENT_DETAIL_UPDATE_BAD_DEBT_SUCCESS:
    case FETCH_PAYMENT_DETAIL_UPDATE_PAYMENT_SUCCESS:
    case FETCH_PAYMENT_DETAIL_INVOICE_FILE_FAIL:
    case FETCH_PAYMENT_DETAIL_RECEIPT_FILE_FAIL:
    case FETCH_PAYMENT_DETAIL_UPDATE_BAD_DEBT_FAIL:
    case FETCH_PAYMENT_DETAIL_UPDATE_PAYMENT_FAIL:
      return { ...state, processing: false }
    default:
      return state
  }
}
